<template>
	<CContainer>
		<!-- <CRow>
		<CCol col="12" class="text-center">
			<CButtonGroup>
				<LevelBtn v-for="(level, index) in levels" :level="level" :key="index" @click="setActiveLevel(level.value)" :active="level.value === activeLevel" />
			</CButtonGroup>
		</CCol>
		</CRow>-->

		<CRow>
			<CCol col="12" md="12" lg="10" class="mx-auto px-0">
				<CAlert
					color="warning"
				>با سرویس کمیسیون‌های افیلی به راحتی کمیسیون‌های بازاریابان را تحت شرایط مختلف شخصی سازی کنید. هر تنظیمات کمیسیونی که در سطر پایین‌تری قرار دارد می‌تواند تمام تنظیمات ما قبل خود را رونویسی کند.</CAlert>
			</CCol>
		</CRow>

		<CRow class="mt-3 mt-md-4">
			<ItemBox v-for="(item, index) in items" :key="index" :item="item" v-show="item.showCondition" />
		</CRow>
	</CContainer>
</template>

<script>
import { ItemBox } from './components'
import { mapGetters } from 'vuex'

export default {
	name: 'List',

	components: {
		ItemBox,
	},

	data() {
		return {
			localStoreId: false,
			activeLevel: 3 // to active all levels
		}
	},
	computed: {
		...mapGetters({
			storeById: 'store/storeById',
		}),
		store() {
			return this.storeById(this.storeId) || this.$currentUser().store
		},
		storeId: {
			get() {
				return this.localStoreId || this.$route.params.store_id || this.$currentUser().store.id || false
			},
			set(newVal) {
				this.localStoreId = newVal
			}
		},
		items() {
			const storeId = this.storeId

			const items = [
				{
					showCondition: true,
					to: { name: 'v2.commissions.default', params: { store_id: storeId } },
					title: this.$t('v2commission.models.default._'),
					level: this.$t('v2commission.levels.standard'),
					description: this.$t('v2commission.models.default.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.default.stat')
					},
					color: 'affili-eggplant',
				},
				{
					showCondition: true,
					to: { name: 'v2.commissions.groups', params: { store_id: storeId } },
					title: this.$t('v2commission.models.group._'),
					level: this.$t('v2commission.levels.standard'),
					description: this.$t('v2commission.models.group.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.group.stat')
					},
					color: 'affili-eggplant',
				},
				{
					showCondition: true,
					to: { name: 'publishers.list', params: { store_id: storeId } },
					title: this.$t('v2commission.models.individual._'),
					level: this.$t('v2commission.levels.standard'),
					description: this.$t('v2commission.models.individual.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.individual.stat')
					},
					color: 'affili-eggplant',
				},
				{
					showCondition: this.activeLevel >= 1,
					to: { name: 'v2.commissions.tiers', params: { store_id: storeId } },
					title: this.$t('v2commission.models.transaction_tier._'),
					level: this.$t('v2commission.levels.intermediate'),
					description: this.$t('v2commission.models.transaction_tier.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.transaction_tier.stat')
					},
					color: 'affili-indigo',
				},
				{
					showCondition: true,
					to: { name: 'v2.commissions.categories', params: { store_id: storeId } },
					title: this.$t('v2commission.models.category_base._'),
					level: this.$t('v2commission.levels.advance'),
					description: this.$t('v2commission.models.category_base.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.category_base.stat')
					},
					color: 'forestgreen',
					comming_soon: false,
					lock: this.store.has_product ? false : true,
				},
				{
					showCondition: this.activeLevel >= 2,
					to: { name: 'v2.commissions.products', params: { store_id: storeId } },
					title: this.$t('v2commission.models.product_base._'),
					level: this.$t('v2commission.levels.advance'),
					description: this.$t('v2commission.models.product_base.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.product_base.stat')
					},
					color: 'forestgreen',
					comming_soon: false,
					lock: this.store.has_product ? false : true,
				},
				{
					showCondition: this.activeLevel >= 1,
					to: { name: 'v2.commissions.rules', params: { store_id: storeId } },
					title: this.$t('v2commission.models.global_commission_rule._'),
					level: this.$t('v2commission.levels.intermediate'),
					description: this.$t('v2commission.models.global_commission_rule.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.global_commission_rule.stat')
					},
					color: 'affili-indigo',
				},
				{
					showCondition: this.activeLevel >= 1,
					to: { name: 'publishers.list', params: { store_id: storeId } },
					title: this.$t('v2commission.models.individual_commission_rule._'),
					level: this.$t('v2commission.levels.intermediate'),
					description: this.$t('v2commission.models.individual_commission_rule.description'),
					stat: {
						number: '2',
						description: this.$t('v2commission.models.individual_commission_rule.stat')
					},
					color: 'affili-indigo',
				},
			]

			return items
		},
		levels() {
			const levels = [
				{
					name: this.$t('v2commission.levels.standard'),
					value: 0,
				},
				{
					name: this.$t('v2commission.levels.intermediate'),
					value: 1,
				},
				{
					name: this.$t('v2commission.levels.advance'),
					value: 2,
				}
			]

			return levels
		}
	},

	methods: {
		setActiveLevel(level) {
			this.activeLevel = level
		}
	}
}
</script>